import React, { useState } from "react";

interface AccordionItem {
  id: string;
  title: string;
  content: React.ReactNode;
}

const Accordion = ({ items }: { items: AccordionItem[] }) => {
  const [openId, setOpenId] = useState<string | null>(null);

  const handleToggle = (id: string | null) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="space-y-4">
      {items.map((item) => (
        <div key={item.id}>
          <button
            onClick={() => handleToggle(item.id)}
            className="flex w-full cursor-pointer items-center justify-between gap-1.5 rounded-lg p-4 bg-transparent hover:bg-gray-100 transition-colors duration-300 py-2 my-2 border-y border-[#E4E4E4]"
          >
            <h2 className="font-medium text-gray-900">{item.title}</h2>
            <svg
              className={`w-5 h-5 shrink-0 transition-transform duration-300 ${
                openId === item.id ? "rotate-180" : ""
              }`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
          {openId === item.id && (
            <div className="mt-4 px-4 leading-relaxed text-gray-700 relative">
              <div className="absolute bg-transparent left-0 top-0 bottom-0 z-10 w-full h-full"></div>
              {item.content}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
